/* global ga */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import md5 from 'md5';

import { trans } from '@spotahome/soyuz-trans/client';

import {
  handleSuccessToast,
  handleErrorToast,
  handleToast
} from '../utils/loginToast';

import { useCookieContext } from '../../context/CookiesContext';

import { USER_EMPTY, USER_NOT_REQUESTED } from './constants';

import LoginButton from './LoginButton';

const setUserId = userEmail => {
  if (typeof ga !== 'undefined' && userEmail) {
    const userId = md5(userEmail);
    ga('set', 'userId', userId);
  }
};

const LoginButtonWrapper = ({ getLoggedInUserInfo, ...restProps }) => {
  const [userInfo, setUserInfo] = useState(USER_NOT_REQUESTED);
  const { getCookie } = useCookieContext();

  useEffect(() => {
    const requestUserData = async () => {
      try {
        const { data } = await getLoggedInUserInfo();
        let userData = USER_EMPTY;
        if (data) {
          handleSuccessToast(data.firstLogin, data.validationActivationSuccess);
          setUserId(data.email);
          userData = data;
        }
        setUserInfo(userData);
      } catch (err) {
        setUserInfo(USER_EMPTY);
        handleErrorToast(err.response);
      }
    };

    const hasFacebookError = getCookie('sah-facebook-error');
    if (hasFacebookError === '1') {
      handleToast(trans('login.error.facebook.email'));
      setUserInfo(USER_EMPTY);
    } else {
      requestUserData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <LoginButton {...restProps} userInfo={userInfo} />;
};

LoginButtonWrapper.propTypes = {
  getLoggedInUserInfo: PropTypes.func
};

LoginButtonWrapper.defaultProps = {
  getLoggedInUserInfo: () => {}
};

export default LoginButtonWrapper;
